import {UsersListToolbar} from './UserListToolbar'
import {UsersListGrouping} from './UsersListGrouping'
import {UsersListSearchComponent} from './UsersListSearchComponent'
import {useBatchApproval} from '../../../../../../context/BatchApprovalContext'

const UsersListHeader = ({
  onSearch = (s: string) => {},
  onFilter = (params: object) => {},
  onBatchDone = () => {},
}) => {
  const {selectedDocs} = useBatchApproval()

  return (
    <div className='card-header border-0 pt-6'>
      <UsersListSearchComponent onSearch={onSearch} onFilter={onFilter} />
      <div className='d-flex align-items-center'>
        {selectedDocs.size > 0 ? <UsersListGrouping onDone={onBatchDone} /> : <UsersListToolbar />}
      </div>
    </div>
  )
}

export {UsersListHeader}
